export default __webpack_public_path__ + "static/media/fernando-redes.42c5228d.jpg";